import React, {useEffect} from "react";
import {Box, makeStyles, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import {useI18N} from "../../../common/common";
import CustomButton from "../../widget/button/CustomButton";
import ResponsiveDialog from "../../widget/dialog/ResponsiveDialog";
import {useAnalytics} from "../../../store/providers/AnalyticsProvider";

const useStyles = makeStyles((theme) => ({
    alignFlex: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& button": {
            width: "100%"
        }
    },
    my3: {
        margin: theme.spacing(3, 0)
    },
    mb2: {
        marginBottom: theme.spacing(2)
    }
}));

const TrialTripsLimitDialog = ({isOpen, onClose, disableBackdropClick, hasCloseButton, onFirstAction, onSecondAction}) => {

    const classes = useStyles();
    const {i18n} = useI18N();
    const {sendCustomEvent, eventNames} = useAnalytics();

    useEffect(() => {
        if (isOpen) {
            sendCustomEvent({
                event_name: eventNames.THREE_BOOKING_POPUP_IMPRESSION
            });
        }
    }, [isOpen]);

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={onClose}
            disableBackdropClick={disableBackdropClick}
            hasCloseButton={hasCloseButton}
            content={
                <Box className={classes.alignFlex}>
                    <img
                        src="/images/cat-becomes-member-no-mask-blue-notification.svg"
                        alt="cat-img"
                        width={100}
                        height={100}
                    />
                    <Typography
                        align="center"
                        variant="h3"
                        className={classes.my3}
                    >
                        {i18n("view.reservations.trial_already_enjoyed")}
                    </Typography>
                    <Typography variant="body1">
                        {i18n("view.reservations.trial_unlock_next_trip")}
                    </Typography>
                </Box>
            }
            actions={
                <Box className={classes.alignFlex}>
                    <CustomButton
                        className={classes.mb2}
                        variant="contained"
                        size="large"
                        onClick={() => onFirstAction()}
                    >
                        {i18n("view.auth.title.become_member")}
                    </CustomButton>
                    <CustomButton
                        variant="outlined"
                        color="black"
                        size="large"
                        onClick={() => onSecondAction()}
                    >
                        {i18n("view.profile.points_shares.buy_points.error.no_buy_rights.action2")}
                    </CustomButton>
                </Box>
            }
        />
    );
};

TrialTripsLimitDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    disableBackdropClick: PropTypes.bool,
    hasCloseButton: PropTypes.bool,
    onFirstAction: PropTypes.func,
    onSecondAction: PropTypes.func
};

export default TrialTripsLimitDialog;
